export const GET_LINK_AGG = 'GET_LINK_AGG';
export const GET_LINK_AGG_FAIL = 'GET_LINK_AGG_FAIL';
export const GET_LINK_AGG_SUCCESS = 'GET_LINK_AGG_SUCCESS';
export const GET_LINK_AGG_SUCCESS_MSG = 'SWITCH_DETAILS_RETRIEVED_SUCCESSFULLY';

export const UPDATE_LINK_AGG = 'UPDATE_LINK_AGG';
export const UPDATE_LINK_AGG_FAIL = 'UPDATE_LINK_AGG_FAIL';
export const UPDATE_LINK_AGG_SUCCESS = 'UPDATE_LINK_AGG_SUCCESS';
export const UPDATE_LINK_AGG_SUCCESS_MSG =
	'SWITCH_CONFIGURATION_UPDATED_SUCCESSFULLY';
export const RESET_UPDATE_LINK_AGG = 'RESET_UPDATE_LINK_AGG';
